const DEFAULT_API_PORT = 8000;

const resolveApiBase = () => {
  const configured = import.meta.env.VITE_API_BASE_URL;
  if (configured) {
    try {
      const origin =
        typeof window !== "undefined"
          ? window.location.origin
          : `http://localhost:${DEFAULT_API_PORT}`;
      const url = new URL(configured, origin);
      const host = url.hostname.toLowerCase();
      const isLocalConfigured = host === "localhost" || host === "127.0.0.1";
      const isRunningLocal =
        typeof window !== "undefined" &&
        (window.location.hostname === "localhost" ||
          window.location.hostname === "127.0.0.1");
      if (isLocalConfigured && !isRunningLocal) {
        // fall through to same-origin /api below
      } else {
        return url.toString();
      }
    } catch {
      if (configured.startsWith("/")) {
        return configured;
      }
    }
  }
  if (typeof window !== "undefined") {
    return `${window.location.origin}/api`;
  }
  return `http://localhost:${DEFAULT_API_PORT}`;
};

export const API_BASE_URL = resolveApiBase().replace(/\/$/, "");

export const gigsEndpoint = `${API_BASE_URL}/gigs/`;
export const availabilityEndpoint = `${API_BASE_URL}/availability/`;
export const authRegisterEndpoint = `${API_BASE_URL}/auth/register`;
export const authLoginEndpoint = `${API_BASE_URL}/auth/login`;
export const authMeEndpoint = `${API_BASE_URL}/auth/me`;
export const authGoogleStartEndpoint = `${API_BASE_URL}/auth/google/start`;
export const artistProfileEndpoint = `${API_BASE_URL}/artists/me/profile`;
export const artistsEndpoint = `${API_BASE_URL}/artists/`;
export const contactsIncomingEndpoint = `${API_BASE_URL}/contacts/incoming`;
export const contactsOutgoingEndpoint = `${API_BASE_URL}/contacts/outgoing`;
export const contactsMarkReadEndpoint = (id) =>
  `${API_BASE_URL}/contacts/${id}/read`;
export const contactThreadEndpoint = (id) =>
  `${API_BASE_URL}/contacts/${id}/thread`;
export const contactMessagesEndpoint = (id) =>
  `${API_BASE_URL}/contacts/${id}/messages`;
export const unreadCountsEndpoint = `${API_BASE_URL}/contacts/unread_counts`;
export const gigEndpoint = (gigId) => `${API_BASE_URL}/gigs/${gigId}`;
export const gigInterestedEndpoint = (gigId) =>
  `${API_BASE_URL}/gigs/${gigId}/interested`;
export const bookingsEndpoint = `${API_BASE_URL}/bookings`;
export const bookingAcceptEndpoint = (id) =>
  `${API_BASE_URL}/bookings/${id}/accept`;
export const bookingDeclineEndpoint = (id) =>
  `${API_BASE_URL}/bookings/${id}/decline`;
export const bookingCancelEndpoint = (id) =>
  `${API_BASE_URL}/bookings/${id}/cancel`;
export const bookingReopenEndpoint = (id) =>
  `${API_BASE_URL}/bookings/${id}/reopen`;
export const bookingCounterEndpoint = (id) =>
  `${API_BASE_URL}/bookings/${id}/counter`;
export const contractSignEndpoint = (id) =>
  `${API_BASE_URL}/contracts/${id}/sign`;
export const paymentsDepositEndpoint = `${API_BASE_URL}/payments/deposit`;
export const authMeTypeEndpoint = `${API_BASE_URL}/auth/me/type`;

export const DEV_FALLBACK_ENABLED = import.meta.env.DEV;
export const AUTH_STORAGE_KEY = "onetrack_token";
